"use client";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { client } from "@/lib/hono";
import { t } from "@/lib/localization";
import toast from "@/lib/toast";
import * as XLSX from "xlsx";

const sanitizeFileName = (value: string) =>
    value.trim().replace(/[\\/:*?"<>|]/g, "_");

export default function DownloadFolderDropdownMenuItem({
    folderId,
}: {
    folderId: string;
}) {
    const downloadFolder = async () => {
        const downloadRes = await client.api.storage.folder[
            ":folderId"
        ].download.$get(
            {
                param: { folderId },
            }
        );

        if (!downloadRes.ok) {
            throw new Error(t("toast.error.export-folder"));
        }

        const { data } = (await downloadRes.json()) as {
            data: {
                id: string;
                title: string | null;
                length: number | null;
                folderName: string;
                downloadUrl: string;
            }[];
        };

        const rows = data.map((video) => ({
            [t("storage.download.xlsx.header.video-id")]: video.id,
            [t("storage.download.xlsx.header.video-title")]: video.title ?? "",
            [t("storage.download.xlsx.header.video-length")]: video.length ?? "",
            [t("storage.download.xlsx.header.video-folder-name")]:
                video.folderName,
            [t("storage.download.xlsx.header.video-download-url")]:
                video.downloadUrl,
        }));

        const sheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            sheet,
            t("storage.download.xlsx.sheet-name")
        );

        const safeFolderName = data[0]?.folderName
            ? sanitizeFileName(data[0].folderName)
            : "folder";
        const filename = t("storage.download.xlsx.filename", undefined, {
            folderName: safeFolderName,
        });

        XLSX.writeFile(workbook, filename);
    };

    return (
        <DropdownMenuItem
            onClick={(e) => {
                e.stopPropagation();
                toast.promise(
                    downloadFolder(),
                    {
                        loading: t("toast.loading.export-folder"),
                        success: t("toast.success.export-folder"),
                        error: t("toast.error.export-folder"),
                    },
                    {
                        loading: {
                            keyName: "toast.loading.export-folder",
                        },
                        success: {
                            keyName: "toast.success.export-folder",
                        },
                        error: {
                            keyName: "toast.error.export-folder",
                        },
                    }
                );
            }}
        >
            {t("storage.folders-grid.item.options.download", undefined, undefined)}
        </DropdownMenuItem>
    );
}
